import {ReportType} from "../report/reportType";
/**
 * Created by alex.y on 9/20/2017.
 */
export class ReportSearchRequest {
    public StartDate?: Date;
    public EndDate?: Date;
    public AgentIds: Array<number> = [];
    public ReportType: ReportType;

    constructor(obj?: Partial<ReportSearchRequest>) {
        Object.assign(this, obj);
    }
}


// WEBPACK FOOTER //
// ./app/objects/requests/reportSearchRequest.ts